import styled from 'styled-components';
import tokens from '@veneer/tokens';
import { Theme } from '@veneer/theme';
import { ButtonGroup, InlineNotification, TextBox } from '@veneer/core';

export const DeviceDetailsContainer = styled.div<{ $veneerTheme: Theme }>`
  padding: 0
    calc(
      ${({ $veneerTheme }) => $veneerTheme.layout.size8} +
        ${({ $veneerTheme }) => $veneerTheme.layout.size6}
    );
  @media (max-width: 1160px) {
    padding: 0
      calc(
        ${({ $veneerTheme }) => $veneerTheme.layout.size8} +
          ${({ $veneerTheme }) => $veneerTheme.layout.size2}
      );
  }
  @media (max-width: 768px) {
    padding: 0 calc(${({ $veneerTheme }) => $veneerTheme.layout.size4});
  }
`;

export const DeviceItemContainer = styled.div<{ $veneerTheme: Theme }>`
  padding: ${({ $veneerTheme }) => $veneerTheme.layout.size7}
    calc(
      ${({ $veneerTheme }) => $veneerTheme.layout.size8} +
        ${({ $veneerTheme }) => $veneerTheme.layout.size2}
    );
  display: flex;
  flex-direction: column;
  & > * + * {
    margin-top: ${tokens.layout.size5};
  }
  @media (max-width: 1160px) {
    padding: ${({ $veneerTheme }) =>
      `${$veneerTheme.layout.size7} ${$veneerTheme.layout.size1}`};
  }
  @media (max-width: 1059px) {
    padding: ${({ $veneerTheme }) =>
      `${$veneerTheme.layout.size7} ${$veneerTheme.layout.size5}`};
  }
`;

export const DeviceCardContainer = styled.div<{ $veneerTheme: Theme }>`
  display: grid;
  gap: ${tokens.layout.size6};
  grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
  @media (max-width: 1160px) {
    grid-template-columns: repeat(2, 1fr);
    gap: ${tokens.layout.size4};
  }
  @media (max-width: 1059px) {
    grid-template-columns: 1fr;
  }
`;

export const DeviceCardImageWrapper = styled.div`
  margin-top: ${tokens.layout.size2};
  margin: auto;
  height: 169px;
  width: 283px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const NoImagePlaceholder = styled.div<{ $veneerTheme: Theme }>`
  height: 169px; /* Match the height of the image container */
  max-width: 283px; /* Match the width of the image container */
  width: 100%;
  background-color: ${({ $veneerTheme }) => $veneerTheme.color.gray3};
`;

export const DeviceCardHeader = styled.div<{ $veneerTheme: Theme }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0;
  @media (max-width: 1160px) {
    padding: 0 ${({ $veneerTheme }) => $veneerTheme.layout.size7};
  }
  @media (max-width: 1059px) {
    padding: 0;
  }
`;

export const DeviceCardTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${tokens.layout.size1};
`;

export const DeviceDetailCaption = styled.div`
  gap: 0;
  text-align: start;
`;

export const DeviceDetailCaptionText = styled.p<{ $veneerTheme: Theme }>`
  color: ${({ $veneerTheme }) => $veneerTheme.color.foreground.light};
`;

export const DeviceCardFooter = styled(ButtonGroup)<{ $veneerTheme: Theme }>`
  display: flex;
  justify-content: center;
`;

export const LearnMoreButtonContainer = styled.div<{ $veneerTheme: Theme }>`
  display: flex;
  align-items: center;
  gap: ${({ $veneerTheme }) => $veneerTheme.layout.size1};
`;

export const ScreenReaderOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const InlineNotificationContainer = styled.div<{ $veneerTheme: Theme }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $veneerTheme }) => $veneerTheme.layout.size3};
`;

export const StyledInlineNotification = styled(InlineNotification)`
  > div {
    align-items: flex-start;
  }
`;

export const TextBoxContainer = styled.div`
  width: 424px;
  @media (width < 616px) {
    width: 100%;
  }
`;

export const StyledTextbox = styled(TextBox)<{ $veneerTheme: Theme }>`
  text-align: left;
  && input {
    background-color: ${({ $veneerTheme }) =>
      $veneerTheme.color.background.container.default};
    color: ${({ $veneerTheme }) => $veneerTheme.color.foreground.default};
  }
`;

export const InlineErrorCard = styled.div<{ $veneerTheme: Theme }>`
  padding: 0;
  @media (max-width: 1160px) {
    padding: 0 ${({ $veneerTheme }) => $veneerTheme.layout.size7};
  }
  @media (max-width: 1059px) {
    padding: 0;
  }
`;
